// @flow

const vb = require('./definition');

vb.addressHouse = () => {
	return {
		validator: v => !v || /^[ёа-яЁА-Я\d/()№,.\s'`-]+$/i.test(v),
		message: () => [
			'введите корректный дом',
			'исправьте',
		],
	};
};

vb.addressApartment = () => {
	return {
		validator: v => !v || /^[ёа-яЁА-Я\d/()№,.\s'`-]+$/i.test(v),
		message: () => [
			'введите корректную квартиру',
			'исправьте',
		],
	};
};


vb.addressLine = (message) => {
	return vb.all([
		vb.regex(/(^[ёа-яЁА-Яa-zA-Z0-9\d \.\-]*$)/, message),
	]);
};